<script>
export default {
  name: "propertyIconSet"
};
</script>

<template>
  <el-row style="padding: 40px 20px; background-color: #FFF">
    <el-row :gutter="10">
      <el-col :span="12" :xs="24">
        <el-row style="display: flex; justify-content: center">
          <el-col :span="24" class="flex-centered">
            <div class="icon-offset-new-property">
              <img class="feature-icon"
                   loading="lazy"
                   src="../../assets/brand-new-property-only.svg"
              />
            </div>

          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-title">
            <span>Real Estate Built For You</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-desc">
            <span
              >Save time and money by exploring land and newly built homes for sale that have never been lived in</span
            >
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" :xs="24">
        <el-row style="display: flex; justify-content: center">
          <el-col :span="24" class="flex-centered">
            <div class="icon-offset-transparency">
              <img class="feature-icon"
                loading="lazy"
                src="../../assets/discover-with-transparency.svg"
              />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-title">
            <span>Explore Every Detail</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-desc">
            <span
              >With more real estate information than any other platform, you can analyse every aspect before you decide</span
            >
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12" :xs="24" style="padding-top: 30px">
        <el-row style="display: flex; justify-content: center">
          <el-col :span="24" class="flex-centered">

            <div class="icon-offset-buy-online">
             <img class="feature-icon" loading="lazy" src="../../assets/buy-online.svg" />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-title">
            <span>Enquire and Select Online</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-desc">
            <span>Contact the agent or begin the buying process by selecting your preferred property online</span>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" :xs="24" style="padding-top: 30px">
        <el-row style="display: flex; justify-content: center">
          <el-col :span="24" class="flex-centered">
            <div class="icon-offset-price-list">
              <img class="feature-icon" loading="lazy" src="../../assets/live-pricelist.svg" />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-title">
            <span>Live Pricing with No Surprises</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="flex-centered font-desc">
            <span>Pricing, availability and associated fees are available for every project, so you know the costs involved with buying your next home</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<style scoped>
.flex-centered {
  display: flex;
  justify-content: center;
  text-align: center;
}

.font-title {
  color: #003333;
  align-self: stretch;
  margin-top: 22px;
  font: 400 30px DINosaur-a, sans-serif;
}

.font-desc {
  color: #003333;
  margin-top: 12px;
  font: 400 16px/20px DINosaur-a, sans-serif;
}

.feature-icon {
  aspect-ratio: auto;
  object-fit: contain;
  object-position: center;
  width: 70px;
  overflow: hidden;
  max-width: 100%;
  padding: 0 0 12px 12px;
  margin-top: 40px;
}

.icon-offset-new-property,
.icon-offset-price-list{
  outline: 4px solid #003333;
  outline-offset: 10px;
}

.icon-offset-transparency {
  outline: 4px solid #003333;
  border-radius: 0 40px 0 0;
  outline-offset: 10px;
}

.icon-offset-buy-online {
  outline: 4px solid #003333;
  border-radius: 0 0 0 40px;
  outline-offset: 10px;
}

@media only screen and (max-width: 764px) {
  .font-desc {
    margin-bottom: 15px;
  }
  .icon-offset-new-property {
    border-radius: 0 40px 0 0;
  }

  .icon-offset-transparency,
  .icon-offset-buy-online{
    border-radius: 0;
  }
  .icon-offset-price-list {
    outline: 4px solid #003333;
    border-radius: 0 0 0 40px;
    outline-offset: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/package/propertyIconSet.vue